import React from "react"
import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import useAuth from "hooks/useAuth"
import useExternalGroups from "hooks/useExternalGroups"

const GroupVisibility = () => {
  const groups = useExternalGroups()
  const {
    user: { currentDepartment: dept },
  } = useAuth()

  return (
    <>
      <div>
        <StaticMultiSelector
          fill={true}
          big={false}
          label="Groups"
          items={groups ?? []}
          path="groupVisibility"
        />
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <StaticMultiSelector
            fill={true}
            label="Company Visibility"
            helperText="the broadcast will be restricted to the given companies"
            path="companyVisibility"
            items={dept?.companies ?? []}
          />
        </div>
      </div>
    </>
  )
}

export default GroupVisibility
